/*
 * Public API Surface of angular-icon-morphing
 */

export * from './lib/angular-icon-morphing.service';
export * from './lib/icon/icon.component';
export * from './lib/angular-icon-morphing.module';
